<template>
  <div class="page1">
    <div class="page1-t">
      <div class="page1-t-l">
        <el-button type="primary" plain>取消全选</el-button>
        <el-button type="primary" plain>删除</el-button>
        <label>
          <span>所属年度:</span>
          <el-date-picker style="width: 160px" type="year" placeholder="请选择年份" v-model="year" />
        </label>
      </div>

      <el-button type="primary" @click="gotoNext">填表式申报</el-button>
    </div>

    <div class="page1-b">
      <el-scrollbar always>
        <div class="add-btn" @click="add" v-if="isShowAdd">
          <el-icon color="#5db6ff" :size="44"><CirclePlus /></el-icon>
          <span>新增税种</span>
        </div>

        <div class="add-wrap" v-else>
          <div class="shui-tips">印花税</div>

          <div class="shui-top" @mouseenter="maskShow = true" @mouseleave="maskShow = false">
            <div class="shui-top-item">
              <div class="top-item-tips">{{ viewData.num1 }}</div>
              <div class="top-item-text"><span class="blue"></span>合计应纳税额(元)</div>
            </div>

            <div class="shui-top-item">
              <div class="top-item-tips">{{ viewData.num2 }}</div>
              <div class="top-item-text"><span class="blue"></span>合计减免税额(元)</div>
            </div>

            <div class="shui-top-item">
              <div class="top-item-tips color">{{ viewData.num3 }}</div>
              <div class="top-item-text"><span class="red"></span>应补(退)税额(元)</div>
            </div>

            <div class="masking" :class="{ 'is-hidden': !maskShow }">
              <el-button round style="color: rgb(64, 158, 255)" size="large">查看申报</el-button>
              <el-button round type="primary" size="large" @click="gotoNext">税源采集</el-button>
            </div>
          </div>

          <div class="shui-bottom">
            <div>纳税属期 {{ viewData.startTime }} 至 {{ viewData.endTime }}</div>
            <div>
              <el-checkbox disabled label="普惠减免" />
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <div class="fix-wrap-b" v-if="isTaxSubmit && props.data.length > 0">
      <div>
        <p>实际应补（退）所得税额 {{ viewData.num3 }} 元，({{ numberToChinese(viewData.num3) }})</p>
        <div class="fix-wrap-b-r">
          <el-button>预览表单</el-button>
          <el-button plain type="primary" @click="taxSubmit">提交申报</el-button>
        </div>
      </div>
    </div>
  </div>

  <el-dialog v-model="dialogVisible" title="增加本期申报税种" width="900" destroy-on-close :before-close="handleClose">
    <div class="add-dialog">
      <div class="add-dialog-t">
        <el-checkbox label="全选" />
      </div>

      <div class="add-dialog-b">
        <div class="add-item" @click="optionsActive = index" v-for="(item, index) of options" :key="index" :class="{ active: index == optionsActive }">
          <div class="add-item-l">
            <div class="add-item-l-icon">
              <el-icon :size="25" color="#ffffff"><OfficeBuilding /></el-icon>
            </div>
          </div>

          <div class="add-item-r">
            {{ item.label }}
          </div>

          <div class="top-sanjiao"></div>
          <div class="bottom-sanjiao"></div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">取消</el-button>
        <el-button type="primary" @click="confirm" size="large">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { numberToChinese } from "@/utils/ruoyi";
import { $emit, $on } from "vue-happy-bus";
import Big from "big.js";

const props = defineProps({
  data: {
    default: () => [],
  },
  status: {
    default: 0,
  },
  isTaxSubmit: {
    default: false,
  },
});

const viewData = computed(() => {
  const viewData = {
    startTime: "--",
    endTime: "--",
    num1: "--",
    num2: "--",
    num3: "--",
  };

  if (props.data.length == 0) {
    return viewData;
  }

  const startTime = props.data[0].startTime;
  const endTime = props.data[0].endTime;
  const num1 = parseFloatNum(props.data.reduce((a, b) => new Big(a).plus(b.amountPayable), 0));
  const num2 = parseFloatNum(new Big(num1).div(2).round(2).toNumber());
  const num3 = parseFloatNum(new Big(num1).minus(num2));

  return {
    startTime,
    endTime,
    num1,
    num2,
    num3,
  };
});

const isShowAdd = computed(() => {
  if (props.data.length > 0) {
    return false;
  }

  return isAdd.value;
});

const year = ref("");
const isAdd = ref(true);
const maskShow = ref(false);
const dialogVisible = ref(false);
const optionsActive = ref(0);
const options = [
  {
    label: "印花税",
  },
  {
    label: "契税",
  },
  {
    label: "土地增值税",
  },
  {
    label: "资源税",
  },
  {
    label: "城镇土地使用税",
  },
  {
    label: "房产税",
  },
  {
    label: "车船税",
  },
  {
    label: "耕地占用税",
  },
  {
    label: "环境保护税",
  },
  {
    label: "烟叶税",
  },
];
const add = () => {
  dialogVisible.value = true;
};

const confirm = () => {
  isAdd.value = false;
  dialogVisible.value = false;
};

const gotoNext = () => {
  emits("gotoNext");
};

const handleClose = () => {
  dialogVisible.value = false;
};

const emits = defineEmits(["goBack", "gotoNext", "updateData", "taxSubmitShow", "taxSubmit"]);

const taxSubmit = () => {
  emits("taxSubmit");
};

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    return s;
  }
}
</script>

<style scoped lang="scss">
.page1 {
  width: 1200px;
  background-color: #ffffff;
  margin: 0 auto;
  height: calc(100% - 60px);
  box-sizing: border-box;
  padding: 0 24px;
  display: flex;
  flex-direction: column;

  .page1-t {
    padding: 25px 0 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    flex: 0 0 auto;
    overflow: hidden;
    box-sizing: border-box;

    .page1-t-l {
      display: flex;
      align-items: center;

      label {
        display: flex;
        align-items: center;
        margin-left: 20px;

        span {
          padding-right: 8px;
        }
      }
    }
  }

  .page1-b {
    padding: 24px 0;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;

    .add-btn {
      width: 49%;
      height: 250px;
      background-color: #f0f8ff;
      position: relative;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;

      span {
        margin-left: 10px;
      }
    }

    .add-wrap {
      width: 49%;
      height: 250px;
      background-color: #f0f8ff;
      border-radius: 10px;
      position: relative;

      .shui-tips {
        top: 15px;
        left: 0;
        position: absolute;
        line-height: 30px;
        color: 12px;
        color: #fff;
        background-color: #3b85f9;
        padding: 0 10px;
        border-radius: 0 15px 15px 0;
      }

      .shui-top {
        width: 100%;
        height: 80%;
        border: 2px solid #8daad0;
        border-bottom: none;
        display: flex;
        align-items: flex-end;
        justify-content: space-around;
        border-radius: 5px 5px 0 0;
        position: relative;
        box-sizing: border-box;

        .masking {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
          background: linear-gradient(rgba(167, 173, 178, 0.8), rgba(201, 207, 216, 0.8));
          display: flex;
          align-items: center;
          justify-content: center;

          &.is-hidden {
            display: none;
          }
        }

        .shui-top-item {
          padding: 30px 0;

          .color {
            color: #ac1616;
          }
        }

        .top-item-tips {
          text-align: right;
          font-weight: 700;
          line-height: 30px;
          font-size: 20px;
        }

        .top-item-text {
          line-height: 30px;

          span {
            display: inline-block;
            margin-right: 5px;
          }

          .blue {
            width: 8px;
            height: 8px;
            background-color: #97b3e1;
            border-radius: 50%;
          }

          .red {
            width: 8px;
            height: 8px;
            background-color: #faa391;
            border-radius: 50%;
          }
        }
      }

      .shui-bottom {
        width: 100%;
        height: 20%;
        border: 2px solid #8daad0;
        border-top: 2px dashed #e7f0f9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        border-radius: 0 0 5px 5px;
        box-sizing: border-box;

        > div {
          margin: 0 20px;
          font-size: 14px;
        }

        &::before {
          position: absolute;
          right: -8px;
          top: -7px;
          content: "";
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #fff;
          border-color: transparent transparent #84a2cf #84a2cf;
          border-style: solid;
          border-width: 2px;
          transform: rotate(45deg);
        }

        &::after {
          position: absolute;
          left: -8px;
          top: -7px;
          content: "";
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #fff;
          border-color: #84a2cf #84a2cf transparent transparent;
          border-style: solid;
          border-width: 2px;
          transform: rotate(45deg);
        }
      }
    }
  }
}

.add-dialog {
  padding: 20px 0;

  .add-dialog-b {
    padding: 15px 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, 195px);
    grid-template-rows: repeat(3, 80px);
    column-gap: 15px;
    row-gap: 10px;

    .add-item {
      box-shadow: 2px 0px 6px 2px rgba(0, 0, 0, 0.1);
      border: 1px solid rgba(0, 0, 0, 0);
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;
      cursor: pointer;
      position: relative;

      &.active {
        background-color: #edf1fd;
        border: 1px solid #4084fe !important;

        .add-item-l {
          border-right: 1px dashed #4084fe;
        }

        .top-sanjiao {
          position: absolute;
          top: 0;
          left: 27%;

          &::before {
            content: "";
            width: 0;
            height: 0;
            border-top: 7px solid #4084fe;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: relative;
            left: -1px;
            top: 9px;
          }

          &::after {
            content: "";
            width: 0;
            height: 0;
            border-top: 7px solid #fff;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: relative;
            left: -14px;
            top: 8px;
          }
        }

        .bottom-sanjiao {
          position: absolute;
          bottom: 0;
          left: 27%;

          &::before {
            content: "";
            width: 0;
            height: 0;
            border-bottom: 7px solid #4084fe;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: relative;
            left: -1px;
            bottom: 8px;
          }

          &::after {
            content: "";
            width: 0;
            height: 0;
            border-bottom: 7px solid #fff;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            position: relative;
            left: -14px;
            bottom: 7px;
          }
        }

        &::before {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          right: 0;
          top: 0;
          border-top: 15px solid #4084fe;
          border-right: 20px solid #4084fe;
          border-left: 15px solid rgba(0, 0, 0, 0);
          border-bottom: 15px solid rgba(0, 0, 0, 0);
        }

        &::after {
          content: "";
          width: 3px;
          height: 6px;
          position: absolute;
          right: 7px;
          top: 0;
          border-color: transparent #fff #fff transparent;
          border-style: solid;
          border-width: 3px;
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
        }
      }

      .add-item-l {
        width: 27%;
        height: 100%;
        display: flex;
        align-items: center;

        .add-item-l-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #4084fe;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .add-item-r {
        margin-left: 20px;
        font-weight: bold;
      }
    }
  }
}
</style>
